<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-truck mr-2" />Barang Masuk - List Barang (Cabang {{ branchName }})</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="No. Faktur PGI">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="IMEI / SN">
                        <b-form-input v-model="filter.imeiSn" maxlength="100" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status">
                        <b-form-select v-model="filter.status" :options="optStatus" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data barang.
                </template>
                <template v-slot:cell(item)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseStatusVariant(row.item.status)">
                        {{ parseStatusName(row.item.status) }}
                    </b-badge>
                </template>
                <!-- <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail" @click="showDetail(row.item)">
                        <i class="fa fa-fw fa-info" />
                    </b-button>
                    <a v-if="row.item.status != 1" class="ml-2" target="_blank" :href="$BASE_FILE_PATH + '/umgtbrcde/' + row.item.id + '-___-' + row.item.no_faktur_pgi">
                        <b-button size="sm" variant="dark" v-b-tooltip.hover.top title="Cetak Barcode">
                            <i class="fa fa-fw fa-print" />
                        </b-button>
                    </a>
                </template> -->
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <!-- <b-modal id="m-detail" title="Detail Barang" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <DetailBarang :inventoryId="activeItem.id" @approved="onApproved" @edited="processEditedItem" @lost="processLostItem" />
        </b-modal> -->
    </div>
</template>

<script>
import DetailBarang from './DetailBarang.vue'

export default {
    name: 'barang-masuk-barang-list',
    components: {
        DetailBarang
    },
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            branchName: "",

            filter: {
                noFaktur: "",
                imeiSn: "",
                status: 0
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "no_faktur_pgi", label: "No. Faktur PGI", sortable: true },
                { key: "imei_sn", label: "IMEI / SN", sortable: true },
                { key: "status", label: "Status", sortable: true },
                // { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optStatus: [
                { value: 0, text: "Semua" },
                { value: 1, text: "Pending" },
                { value: 2, text: "Approved" },
                { value: 5, text: "Hilang" },
            ]

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(!this.$helper.isBlank(this.filter.imeiSn)) {
                param += "&filterImeiSn=" + this.filter.imeiSn
            }

            if(this.filter.status != 0) {
                param += "&filterStatus=" + this.filter.status
            }
            
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("delivery/batch/" + this.$route.params.batchId + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                this.branchName = res.data.data.branch
                sessionStorage.setItem("listBarangMasukFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        showDetail(item) {
            this.activeItem = item
            this.$bvModal.show("m-detail")
        },

        processEditedItem(type, year) {
            this.activeItem.type = type
            this.activeItem.year = year
            this.$bvModal.hide('m-detail')
        },

        processLostItem() {
            this.$bvModal.hide("m-detail")
            this.$helper.toastSuccess(this, "Barang berhasil dinyatakan hilang!")
            this.getItems(this.currentPage)
        },

        onApproved() {
            this.$bvModal.hide("m-detail")
            this.$helper.toastSuccess(this, "Barang berhasil diapprove!")
            this.getItems(this.currentPage)
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        parseStatusVariant(status) {

            switch(status) {
                case 1: return "warning"
                case 2: return "success"
                case 5: return "danger"
                case 55: return "dark"
                default: return "light"
            }

        },

        parseStatusName(status) {

            switch(status) {
                case 1: return "PENDING"
                case 2: return "APPROVED"
                case 5: return "HILANG"
                case 55: return "REQUEST HILANG"
                default: return "LAINNYA"
            }

        }

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listBarangMasukFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listBarangMasukFilter"))
        }
        this.init()
    }
}
</script>
